import * as PIXI from "pixi.js";
import { GameAssets } from "../util/GameAssets";
import { GlobalState } from "src/shared/util/GlobalState";
import { soundManager } from "./SoundManager";

// Define an enum for the states
export enum SoundButtonState {
    ACTIVE = "ACTIVE",
    PASSIVE = "PASSIVE",
}

export class SoundButton extends PIXI.Container {
    private sprite: PIXI.Sprite;
    public get Sprite() {
        return this.sprite;
    }
    private currentState: SoundButtonState = SoundButtonState.PASSIVE;

    constructor() {
        super();

        this.sprite = new PIXI.Sprite(GameAssets.textures.uiAtlas.textures["soundOff.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("click", this._handleClick, this);
        this.sprite.on("touchend", this._handleClick, this);

        this.addChild(this.sprite);
        this._changeState(SoundButtonState.ACTIVE); // Set initial state to ACTIVE
    }

    private _handleClick() {
        switch (this.currentState) {
            case SoundButtonState.ACTIVE:
                this._changeState(SoundButtonState.PASSIVE);
                break;
            case SoundButtonState.PASSIVE:
                this._changeState(SoundButtonState.ACTIVE);
                break;
        }
    }

    private _onPassive() {
        soundManager.setMuted(true);
        this.sprite.texture = GameAssets.textures.uiAtlas.textures["soundOff.webp"];
        GlobalState.getInstance().updateState({ soundOn: false });
    }

    private _onActive() {
        soundManager.setMuted(false);
        this.sprite.texture = GameAssets.textures.uiAtlas.textures["soundOn.webp"];
        GlobalState.getInstance().updateState({ soundOn: true });
    }

    private _changeState(newState: SoundButtonState) {
        if (this.currentState === newState) return; // No change if the same state

        // Enter logic for the new state
        this.currentState = newState;
        switch (this.currentState) {
            case SoundButtonState.PASSIVE:
                this._onPassive();
                break;
            case SoundButtonState.ACTIVE:
                this._onActive();
                break;
        }
    }
}
